import { COLORS_OPTIONS, MULTICOLOR } from "constants/options";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SelectableList } from "ui";

import {
  ColorsBlockProps,
  ProductFormValues
} from "../ProductDetailsForm.types";

import styles from "../ProductDetailsForm.module.scss";

export const ColorsBlock = ({
  colorAttribute,
  defaultValues
}: ColorsBlockProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<ProductFormValues>();

  return (
    <div className={styles.productForm__block}>
      <h4 className={styles.productForm__block__title}>
        {t("Color Variants")}
      </h4>

      <Controller
        control={control}
        name={`colors`}
        render={({ field: { value, onChange }, fieldState: { error } }) => {
          return (
            <SelectableList
              values={value}
              onChange={onChange}
              options={colorAttribute.values.map((attValue) => ({
                label: attValue.value,
                value: attValue.id as string,
                disabled: defaultValues.colors.some(
                  (color) => color.value === attValue.id
                ),
                color:
                  COLORS_OPTIONS.find((color) => color.value === attValue.value)
                    ?.color ?? MULTICOLOR
              }))}
              errorMessage={error?.message}
            />
          );
        }}
      />
    </div>
  );
};
